"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultFilters = void 0;
const routes_1 = require("../../routes");
const getDefaultFilters = (client) => async (categoryId) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_CUSTOM_CONFIG.applyParams('filters'), {
        params: {
            categoryId,
        },
    });
    return response.data;
};
exports.getDefaultFilters = getDefaultFilters;
